/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PatientGuarantorAddress } from './PatientGuarantorAddress';

export type PatientGuarantorWritable = {
    patient_id: number;
    address?: PatientGuarantorAddress;
    readonly id?: number;
    first_name?: string | null;
    middle_initial?: string | null;
    /**
     * space separated list of middle names
     */
    middle_names?: string | null;
    last_name?: string | null;
    phone?: string | null;
    work_phone?: string | null;
    relationship_to_patient?: string | null;
    date_of_birth?: string | null;
    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    sex?: PatientGuarantorWritable.sex | null;
    ssn?: string | null;
}

export namespace PatientGuarantorWritable {

    /**
     * HL7 single character representation of sex: F, M, O, U, A
     */
    export enum sex {
        M = 'M',
        F = 'F',
        O = 'O',
        U = 'U',
        A = 'A',
    }


}
